export const MODEL_TYPE = {
    ENTERPRISE: 1,
    PARENT_COMPANY: 2,
    COMPANY: 3,
};

// Universal mobile-app login hostnames. These are the single per-environment URLs the
// tbn-driver-portal-mobile WebView loads, regardless of company. They are intentionally
// NOT backed by DriverPortalInstances rows — on these hosts the login presents the
// multi-company picker instead of resolving a single specific portal.
export const UNIVERSAL_LOGIN_HOSTNAMES = [
    'driverportal.tbndrives.com',
    'driverportal-qa.tbndrives.com',
    'driverportal-stage.tbndrives.com',
    'driverportal-dev.tbndrives.com',
];

export const isUniversalLoginHost = (hostname = window.location.hostname) => {
    return UNIVERSAL_LOGIN_HOSTNAMES.includes(hostname);
};

// Routing target only, never the session; left in place on logout since it is inert without a token.
export const rememberPortal = ({ hostname }) => {
    localStorage.setItem('dp_lastPortal', JSON.stringify({ hostname }));
};

export const readRememberedPortal = () => {
    try {
        const target = JSON.parse(localStorage.getItem('dp_lastPortal'));
        if (!target?.hostname || isUniversalLoginHost(target.hostname)) return null;
        return target.hostname === window.location.hostname ? null : target;
    } catch (err) {
        return null;
    }
};

export const getModelTypeId = () => {
    const val = localStorage.getItem('dp_modelTypeID');
    return val !== null ? Number(val) : null;
};

export const getEntityId = () => {
    const val = localStorage.getItem('dp_entityID');
    return val !== null ? Number(val) : null;
};

export const getEnterpriseId = () => {
    return getModelTypeId() === MODEL_TYPE.ENTERPRISE ? getEntityId() : null;
};

export const getParentCompanyId = () => {
    return getModelTypeId() === MODEL_TYPE.PARENT_COMPANY ? getEntityId() : null;
};

export const getCompanyId = () => {
    const user = getCustomerDetails();
    return user?.companyID ?? (getModelTypeId() === MODEL_TYPE.COMPANY ? getEntityId() : null);
};

export const getScopeParams = () => {
    const modelTypeId = getModelTypeId();
    const entityId = getEntityId();
    if (modelTypeId === MODEL_TYPE.ENTERPRISE) return { enterpriseId: entityId };
    if (modelTypeId === MODEL_TYPE.PARENT_COMPANY) return { parentCompanyId: entityId };
    if (modelTypeId === MODEL_TYPE.COMPANY) return { companyId: entityId };
    return {};
};

export const getUserId = () => {
    return localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).id;
};

export const getCustomerDetails = () => {
    return JSON.parse(localStorage.getItem('user'));
};

export const timezoneDescription = () => {
    return localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).timeZoneDescription;
};

export const getModelTypeIDAndEntityID = () => {
    return { modelTypeID: getModelTypeId(), entityID: getEntityId() };
};
